import React, { useMemo } from 'react';
import './style.scss';
import clsx from 'clsx';
import {
  blueBackground,
  getColorSchemaByNFTColors,
  greenBackground
} from '../../../../utils/color';
import { WSPlayer } from 'shared';
import { IFightNft } from '../../../../interfaces/FightNft';

interface Props {
  data: IFightNft | WSPlayer;
  background?: 'blue' | 'green';
  className?: string;
  reversed?: boolean;
}

const NftIcon = ({ data, className, reversed, background }: Props) => {
  const color = useMemo<string>(() => {
    if (background) {
      if (background === 'blue') return blueBackground;
      return greenBackground;
    }
    return getColorSchemaByNFTColors(data.colors).backgrounds.nft;
  }, [data?.colors, background]);

  const disabled = useMemo<boolean>(() => {
    if ('pending' in data) {
      return data.pending || data.failed;
    }
    return false;
  }, [data]);

  return (
    <div
      className={clsx(
        'nft-icon',
        disabled && 'nft-icon-disabled',
        reversed && 'nft-icon-reversed',
        className
      )}
      style={{ background: color }}
    >
      <img src={data.image} />
    </div>
  );
};

export default NftIcon;
